/* eslint-disable @typescript-eslint/no-explicit-any */
import { createClient } from 'contentful';

// const isPreview =
//     typeof location !== 'undefined' &&
//     (location.host.indexOf('staging') > -1 || location.host.indexOf('localhost') > -1);
const isPreview = false;

const SPACE_ID = '99nkt0ulaqdh';
const ACCESS_TOKEN = 'hz5IQoPAfSak7EUHwTRJETBD1-vUzKlAEHGFkxezoGs';
const PREVIEW_ACCESS_TOKEN = 'YbnjiQc0trOt-BPXovQc2FMruAPqYl9fNZjIL5I18RM';
const LIVE_HOST = 'cdn.contentful.com';
const PREVIEW_HOST = 'preview.contentful.com';

const config = {
    space: SPACE_ID,
    accessToken: isPreview ? PREVIEW_ACCESS_TOKEN : ACCESS_TOKEN,
    host: isPreview ? PREVIEW_HOST : LIVE_HOST,
};

const client = createClient({ ...config });

export const ContentfulApiClient = {
    async requestTileData() {
        const entries = await client.getEntries({
            content_type: 'home',
            order: '-sys.createdAt',
            limit: 1,
            include: 10,
        });
        if (entries.items[0]) {
            return transformFactory(entries.items[0])['tiles'];
        } else {
            return [];
        }
    },
};

function transformFactory(item: any): any {
    // Strip Contentful metadata.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { sys, ...props } = item;
    const { fields } = props;
    // Strip Contentful methods.
    for (const p in props) {
        // eslint-disable-line
        if (typeof props[p] === 'function') {
            delete props[p];
        }
        // Deep clean methods.
        if (Array.isArray(props[p]) && props[p].some((ff: any) => typeof ff !== 'string')) {
            props[p] = props[p].map(transformFactory);
        }
    }
    // Deep clean fields.
    if (fields) {
        for (const f in fields) {
            // eslint-disable-line
            const field = fields[f];
            if (field.fields) {
                fields[f] = transformFactory(field);
            }
            if (field.fields && field.fields.file) {
                fields[f] = field.fields.file;
                fields[f].title = field.fields.title;
                fields[f].description = field.fields.description;
            }
            // Deep strip contentful metadata from child array of items.
            if (Array.isArray(field) && field.some((ff) => typeof ff !== 'string')) {
                fields[f] = field.map(transformFactory);
            }
        }
        return transformFactory(fields);
    }
    return props;
}

export function getContentfulImage(src: any, w: any, h?: any, quality = 80, fm = 'jpg') {
    if (
        !src ||
        (src && (src.indexOf('.svg') > -1 || src.indexOf('.mp4') > -1)) ||
        (src && src.indexOf('//') === -1)
    )
        return src; // prevent for local and svg/png/mp4
    // get image from contentful with specific params optimised for web.
    if (w && h)
        return `${src}?w=${w}&h=${h}&${fm === 'jpg' ? 'fit=fill&' : ''}fm=${fm}${
            fm === 'jpg' ? '&fl=progressive' : ''
        }&q=${quality}`;
    if (w) return `${src}?w=${w}&fm=${fm}${fm === 'jpg' ? '&fl=progressive' : ''}&q=${quality}`;
    if (h) return `${src}?h=${h}&fm=${fm}${fm === 'jpg' ? '&fl=progressive' : ''}&q=${quality}`;
    return `${src}?fm=${fm}${fm === 'jpg' ? '&fl=progressive' : ''}&q=${quality}`;
}
